/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AllowedConnectionIpData model module.
 * @module model/AllowedConnectionIpData
 * @version 1.0
 */
class AllowedConnectionIpData {
    /**
     * Constructs a new <code>AllowedConnectionIpData</code>.
     * @alias module:model/AllowedConnectionIpData
     */
    constructor() { 
        
        AllowedConnectionIpData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AllowedConnectionIpData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AllowedConnectionIpData} obj Optional instance to populate.
     * @return {module:model/AllowedConnectionIpData} The populated <code>AllowedConnectionIpData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AllowedConnectionIpData();

            if (data.hasOwnProperty('allowedNo')) {
                obj['allowedNo'] = ApiClient.convertToType(data['allowedNo'], 'Number');
            }
            if (data.hasOwnProperty('beginIpAddr')) {
                obj['beginIpAddr'] = ApiClient.convertToType(data['beginIpAddr'], 'Blob');
            }
            if (data.hasOwnProperty('endIpAddr')) {
                obj['endIpAddr'] = ApiClient.convertToType(data['endIpAddr'], 'Blob');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AllowedConnectionIpData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AllowedConnectionIpData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }

        return true;
    }


}



/**
 * @member {Number} allowedNo
 */
AllowedConnectionIpData.prototype['allowedNo'] = undefined;

/**
 * @member {Blob} beginIpAddr
 */
AllowedConnectionIpData.prototype['beginIpAddr'] = undefined;

/**
 * @member {Blob} endIpAddr
 */
AllowedConnectionIpData.prototype['endIpAddr'] = undefined;

/**
 * @member {String} description
 */
AllowedConnectionIpData.prototype['description'] = undefined;

/**
 * @member {Date} createAt
 */
AllowedConnectionIpData.prototype['createAt'] = undefined;






export default AllowedConnectionIpData;

